// extracted by mini-css-extract-plugin
export var backgroundClassCardContainer = "styles-module--backgroundClassCardContainer--hQfnD";